import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '@jepto/shared/shared.module';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from "@angular/material/expansion";
import { NgScrollbarModule } from 'ngx-scrollbar';

import { CoreService } from '@jepto/core/services/core.service';
import { ContainerLayoutComponent } from '../layouts/container-layout/container-layout.component';
import { DashboardLayoutComponent } from '../layouts/dashboard-layout/dashboard-layout.component';
import { DashMenuComponent } from '../layouts/menubar/menubar.component';
import { SideBarComponent } from '../layouts/sidebar/sidebar.component';
import { DashTopbarComponent } from '../layouts/topbar/topbar.component';
import { GlobalClientsDropdownComponent } from '../layouts/global-clients-dropdown/global-clients-dropdown.component';
import { GlobalClientCreateComponent } from '../layouts/global-clients-create/global-clients-create.component';
import { GlobalPipelinesDropdownComponent } from '../layouts/global-pipelines-dropdown/global-pipelines-dropdown.component';
import { JepFilterPipe } from "@jepto/shared/pipes/jep-filter.pipe";
import { ClientsInsightService } from '@jepto/features/portfolio/services/clients-insight.service';
import { JeptoAiCreditsIncentivesPanelComponent } from '@jepto/features/ai-credits-incentives/components/jepto-ai-credits-incentives-panel/jepto-ai-credits-incentives-panel.component';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        NgScrollbarModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatBadgeModule,
        MatExpansionModule,
        MatTooltipModule,
        JeptoAiCreditsIncentivesPanelComponent
    ],
    declarations: [
        GlobalClientCreateComponent,
        ContainerLayoutComponent,
        DashboardLayoutComponent,
        DashMenuComponent,
        SideBarComponent,
        DashTopbarComponent,
        GlobalClientsDropdownComponent,
        GlobalPipelinesDropdownComponent
    ],
    exports: [ContainerLayoutComponent,
        ContainerLayoutComponent,
        DashboardLayoutComponent,
        DashMenuComponent,
        SideBarComponent,
        DashTopbarComponent,
        GlobalClientsDropdownComponent,
        GlobalPipelinesDropdownComponent],
    providers: [CoreService, JepFilterPipe, ClientsInsightService]
})
export class CoreModule {
    static forRoot() {
        return {
            ngModule: CoreModule,
            providers: []
        };
    }
}